const BASE_PATH = '/task/check/sign'

export default {
  saveSign: data => ({
    url: BASE_PATH,
    method: 'PUT',
    data
  }),
  saveSignResult: data => ({
    url: `${BASE_PATH}/result`,
    method: 'PUT',
    data
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/TaskSign.js